import {ILLProductBase } from './ll-product-base.model';

export class ILLProduct extends ILLProductBase {

  $type: string;
  summaryDetails: string;
  productType: string;
  description: string;
}

